import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { hostInfo } from '@core/models/domains/hotel';
import { cdnUrl, WINDOW } from 'apps/ihowebsite/src/app/app.module';
import { SharedModule } from '@shared/shared.module';

@Component({
 selector: 'iho-pdp-ecolodge-host',
 standalone: true,
 imports: [CommonModule,SharedModule],
 templateUrl: './pdp-ecolodge-host.component.html',
 styleUrls: ['./pdp-ecolodge-host.component.scss'],
})
export class PdpEcolodgeHostComponent {
    cdnUrl = cdnUrl;

 @Input()   get dataSource(): hostInfo | undefined {
        return this._dataSource;
    }
    set dataSource(value: hostInfo | undefined) {
        this._dataSource = value;
    }
     _dataSource!: hostInfo | undefined;


    onImageError(event: any) {
        const target = event.target as HTMLImageElement;
        target.src = 'assets/images/user-accommodation.png'; 
    }
}
